import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { environment } from "src/environments/environment";
import { LoaderService } from "./core/services/loader.service";
import { TranslationService } from "./core/services/translation.service";

@Component({
  selector: "app-root",
  imports: [RouterOutlet],
  templateUrl: "./app.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  private titleService = inject(Title);

  readonly translationService = inject(TranslationService);

  loaderService = inject(LoaderService);
  isLoading = false;
  forceLoading = false;
  showLoader = false;

  constructor() {
    this.setTitle();
  }

  public setTitle(): void {
    const title = environment.TITLE;
    const favIcon = document.querySelector("#favIcon");
    (favIcon as HTMLLinkElement).href = environment.ICON;
    this.titleService.setTitle(title);
  }

  moveScrollToTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (
      event.key === "F12" ||
      (event.ctrlKey && event.shiftKey && event.key === "I") ||
      (event.ctrlKey && event.shiftKey && event.key === "J") ||
      (event.ctrlKey && event.shiftKey && event.key === "C") ||
      (event.ctrlKey && event.key === "U") ||
      (event.metaKey && event.altKey && event.key === "I") ||
      (event.metaKey && event.altKey && event.key === "J") ||
      (event.metaKey && event.altKey && event.key === "C") ||
      (event.metaKey && event.shiftKey && event.key === "C") ||
      (event.ctrlKey && event.shiftKey && event.key === "C") ||
      event.key === "F5" ||
      (event.metaKey && event.key === "C") ||
      (event.metaKey && event.shiftKey && event.key === "D") ||
      (event.metaKey && event.shiftKey && event.key === "K") ||
      (event.metaKey && event.shiftKey && event.key === "I")
    ) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    return true;
  }

  onRightClick(event: MouseEvent): boolean {
    event.preventDefault();
    return false;
  }
}
